import React, { useState, useEffect, useContext } from 'react'
import style from '../components/PageContent/PageContent.module.scss'
import Container from '@bt-react/components/Container'
import MetaHead from '../components/MetaHead'
import { useRouter } from 'next/router'
import isServerSide from '@bt-react/libs/isServerSide'

export const Index = () => {

  const router = useRouter()


  if (!isServerSide && router) {

    if (router.asPath.match(/\w+\.\w*/gi)) {

      return null

    }

    if (router.asPath !== '/all-talks') {

      router.replace('/all-talks')

    }

  }

  return (
    <div className={style['app']}>
      <MetaHead />
      <Container>
        <div className={style['Player-Content']} />
      </Container>
    </div>
  )
}

export default Index
